import { ClassData } from "../../../common/dtos/classes.type";
import { DEFAULT_CATEGORY } from "../../../common/services/default-category.service";
import { getClassesPerWeek } from "../../../common/utils/classes.util";
import {
  LOGIN_BUTTON_LINK,
  RYB_CLASSES_DATA,
  URL_PARAMETERS,
} from "../../../common/utils/const.util";
import {
  calculateTimeDifference,
  convertTo12HourFormat,
} from "../../../common/utils/date.util";
import {
  additionalUrlParameters,
  getPreloadClassId,
  getUrlParameterValue,
  parseRegistrationLink,
} from "../../../common/utils/url.util";
import { getVariantId } from "../../../common/utils/variant.util";
import { openModal } from "../../../common/views/modal.view";
import { setGridClick } from "../../templates/trial/grid";
import { handlePreloadingOfShortcodes } from "../services/shortcodes.service";
import { writeCookie } from "../utils/cookie.util";
import { openModal as finderOpenModal } from "./modal-finder.view";

export function setResultGridView(data: ClassData[]) {
  $("#class-finder .grid-results .monday-results").empty();
  $("#class-finder .grid-results .tuesday-results").empty();
  $("#class-finder .grid-results .wednesday-results").empty();
  $("#class-finder .grid-results .thursday-results").empty();
  $("#class-finder .grid-results .friday-results").empty();
  $("#class-finder .grid-results .saturday-results").empty();
  $("#class-finder .grid-results .sunday-results").empty();

  const isUser = getUrlParameterValue("user");
  const template = document.getElementById(
    "result-grid-cell-template"
  )?.innerHTML;
  if (!template) {
    return;
  }

  const initiatedShortcodes: string[] = [];

  $.each(data, (_index, option) => {
    const rybCategoryData = RYB_CLASSES_DATA.classes?.find(
      (category) => category.name === option[DEFAULT_CATEGORY]
    );
    const categoryName =
      rybCategoryData?.display_name || option[DEFAULT_CATEGORY];

    const categoryLocation = option?.location;
    const status = rybCategoryData?.status || "Hide";
    if (status === "Hide") {
      return; // ignore the box if it's hidden
    }
    const cellElement = $(template);
    const totalTime = calculateTimeDifference(
      option.start_time,
      option.end_time
    );
    const time = option?.start_time
      ? convertTo12HourFormat(option.start_time)
      : { time: "", period: "" };
    cellElement.find(".class-name").text(`${categoryName}`);
    cellElement
      .find("div.class-start")
      .html(
        `<span class="time">${time.time}</span> <span class="period">${time.period}</span>`
      );
    cellElement
      .find("div.classes-per-week")
      .text(
        `${
          getClassesPerWeek(option.meeting_days) > 1
            ? `${getClassesPerWeek(option.meeting_days)} classes per week`
            : "1 class per week"
        }`
      );
    if ($(".result-grid-cell .location-name")) {
      cellElement
        .find(".location-name")
        .text(
          option.location_city && option.location_name
            ? `${option.location_city}, ${option.location_state}`
            : option.location_name
        );
    }
    cellElement.find("div.class-time").text(`${totalTime}`);
    cellElement.find("span.class-price").text(`${option.tuition.fee}`);
    if (status === "Active") {
      cellElement.find(".control-button.invite-only").remove();
      if (option.openings.calculated_openings > 0) {
        cellElement
          .find("div.control-button .enroll-class.enroll")
          .removeClass("d-none");

        cellElement
          .find("div.control-button .enroll-class.trial")
          .removeClass("d-none");
      } else {
        cellElement
          .find("div.control-button .enroll-class.waitlist")
          .removeClass("d-none");
        cellElement
          .find("div.control-button .enroll-class.trial-full")
          .removeClass("d-none");
      }
    } else if (status === "Invite-only") {
      cellElement.find(".control-button.active").remove();
      if (
        rybCategoryData?.invite_only_funnel_shortcode &&
        !initiatedShortcodes.includes(rybCategoryData.display_name)
      ) {
        handlePreloadingOfShortcodes(
          rybCategoryData?.invite_only_funnel_shortcode
        );
        initiatedShortcodes.push(rybCategoryData.display_name);
      }
    } else {
      cellElement.find(".control-button.active").remove();
      cellElement.find(".control-button.invite-only").remove();
      // don't expect anything because class should already be hidden
    }

    function clickActiveClass(
      event: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>
    ) {
      const classId = getPreloadClassId(
        option.online_reg_link,
        "preLoadClassID"
      );
      const orgId = getPreloadClassId(option.online_reg_link, "id");
      const triggerContactModal =
        getUrlParameterValue(URL_PARAMETERS.CONTACT) === "false";

      writeCookie(
        "classData",
        btoa(
          JSON.stringify({
            ...option,
            location: categoryLocation,
            category2: categoryName,
          })
        ),
        365
      );
      if (triggerContactModal) {
        openModal(
          {
            ...option,
            location: categoryLocation,
            category2: categoryName,
          },
          "form"
        );
        return;
      }
      if (!option.online_reg_link || option.online_reg_link === " ") {
        const rybCategoryData = RYB_CLASSES_DATA.classes?.find(
          (category) => category.name === option[DEFAULT_CATEGORY]
        );

        const contactId = localStorage.getItem('ghlContactId');
        if (contactId) {
          $.ajax({
            url: `https://${window.location.host}/wp-json/ryb/v1/ghl?timestamp=${Date.now()}`,
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify({
              request_url: `https://services.leadconnectorhq.com/contacts/${contactId}`,
              include_location_id: false,
              method: "PUT",
              body: {
                customFields: [
                  {
                    key: "selected_class_id",
                    field_value: option.id,
                  },
                  {
                    key: "selected_class_url",
                    field_value: additionalUrlParameters(
                      rybCategoryData?.fallback_url || "",
                      option?.tuition?.fee?.toString(),
                      option.category1,
                      option.category2
                    ),
                  },
                  {
                    key: "last_funnel_url",
                    field_value: new URL(window.location.href),
                  },
                  {
                    key: "step_1",
                    field_value: "Step 5 | Click to Enroll/Waitlist",
                  },
                ],
              }
            })
          })
        }

        window.open(
          additionalUrlParameters(
            rybCategoryData?.fallback_url || "",
            option?.tuition?.fee?.toString(),
            option.category1,
            option.category2
          ),
          "_blank"
        );

        return;
      }
      event.preventDefault();
      if (isUser === "true") {
        window.open(
          `${LOGIN_BUTTON_LINK}?orgId=${orgId}&regcid=${classId}`,
          "_blank"
        );
        return;
      }
      if (isUser === "false") {
        const contactId = localStorage.getItem('ghlContactId');
        if (contactId) {
          $.ajax({
            url: `https://${window.location.host}/wp-json/ryb/v1/ghl?timestamp=${Date.now()}`,
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify({
              request_url: `https://services.leadconnectorhq.com/contacts/${contactId}`,
              include_location_id: false,
              method: "PUT",
              body: {
                customFields: [
                  {
                    key: "selected_class_id",
                    field_value: option.id,
                  },
                  {
                    key: "selected_class_url",
                    field_value: parseRegistrationLink(
                      option.online_reg_link,
                      option.tuition.fee.toString(),
                      option.category1,
                      option.category2)
                  },
                  {
                    key: "last_funnel_url",
                    field_value: new URL(window.location.href),
                  },
                  {
                    key: "step_1",
                    field_value: "Step 5 | Click to Enroll/Waitlist",
                  },
                ],
              }
            })
          })
        }
        
        window.open(
          parseRegistrationLink(
            option.online_reg_link,
            option.tuition.fee.toString(),
            option.category1,
            option.category2
          ),
          "_blank"
        );
        return;
      }
      if (!isUser) {
        window.open(
          parseRegistrationLink(
            option.online_reg_link,
            option.tuition.fee.toString(),
            option.category1,
            option.category2
          ),
          "_blank"
        );
        return;
      }

      openModal({
        ...option,
        location: categoryLocation,
        category2: categoryName,
      });
    }

    cellElement.find(".enroll").on("click", clickActiveClass);
    cellElement.find(".waitlist").on("click", clickActiveClass);

    cellElement.find("button.main-info").on("click", function (event) {
      event.preventDefault();

      openModal(
        {
          ...option,
          location: categoryLocation,
          category2: categoryName,
        },
        "invite-only"
      );
    });
    cellElement.find(".trial").on("click", () => setGridClick(event, option));

    cellElement.find(".info").on("click", function (event) {
      event.preventDefault();
      finderOpenModal({
        ...option,
        location: categoryLocation,
        category2: categoryName,
      });
    });

    if (option.meeting_days.mon) {
      $(".grid-results .monday-results").append(cellElement);
    }
    if (option.meeting_days.tue) {
      $(".grid-results .tuesday-results").append(cellElement);
    }
    if (option.meeting_days.wed) {
      $(".grid-results .wednesday-results").append(cellElement);
    }
    if (option.meeting_days.thu) {
      $(".grid-results .thursday-results").append(cellElement);
    }
    if (option.meeting_days.fri) {
      $(".grid-results .friday-results").append(cellElement);
    }
    if (option.meeting_days.sat) {
      $(".grid-results .saturday-results").append(cellElement);
    }
    if (option.meeting_days.sun) {
      $(".grid-results .sunday-results").append(cellElement);
    }

    $("#form .ryb-connect-modal .register-button").on("click", (event) => {
      event.preventDefault();
      $("#form .ryb-connect-modal .registration-form").addClass("show-field");
      $("#form .ryb-connect-modal .modal-content").removeClass("show-field");
    });
    $("#form.ryb-connect-overlay").on("click", (event) => {
      if ($(event.target).hasClass("show")) {
        $("#form .ryb-connect-modal .registration-form").removeClass(
          "show-field"
        );
        $("#form .ryb-connect-modal .modal-content").addClass("show-field");
      }
    });
  });

  setNoClassesContent();
}

export function setToggleTableFunctionality() {
  $(".grid-results .accordion")
    .off("click")
    .on("click", function () {
      $(this).toggleClass("open");
    });
}

function setNoClassesContent() {
  if (!$(".grid-results .monday-results > div").length) {
    $("#class-finder .grid-results .monday-results").html(
      `<div class="no-result"> No classes found</div>`
    );
  }
  if (!$(".grid-results .tuesday-results > div").length) {
    $("#class-finder .grid-results .tuesday-results").html(
      `<div class="no-result"> No classes found</div>`
    );
  }
  if (!$(".grid-results .wednesday-results > div").length) {
    $("#class-finder .grid-results .wednesday-results").html(
      `<div class="no-result"> No classes found</div>`
    );
  }
  if (!$(".grid-results .thursday-results > div").length) {
    $("#class-finder .grid-results .thursday-results").html(
      `<div class="no-result"> No classes found</div>`
    );
  }
  if (!$(".grid-results .friday-results > div").length) {
    $("#class-finder .grid-results .friday-results").html(
      `<div class="no-result"> No classes found</div>`
    );
  }
  if (!$(".grid-results .saturday-results > div").length) {
    $("#class-finder .grid-results .saturday-results").html(
      `<div class="no-result"> No classes found</div>`
    );
  }
  if (!$(".grid-results .sunday-results > div").length) {
    $("#class-finder .grid-results .sunday-results").html(
      `<div class="no-result"> No classes found</div>`
    );
  }
}
